<p-toast></p-toast>

<app-header *ngIf="showHeader"></app-header>
<app-main [ngClass]="{'pt-0 mb-0 ms-0': !showHeader}">
    <router-outlet></router-outlet>
</app-main>
